import * as React from 'react';
import Calendar from '@mui/icons-material/Event';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { useState } from 'react';
import './Calender.css'

const shortcutsItems = [
      {
        label: 'This Week',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('week'), today.endOf('week')];
        },
      },
      {
        label: 'Last Week',
        getValue: () => {
          const today = dayjs();
          const prevWeek = today.subtract(7, 'day');
          return [prevWeek.startOf('week'), prevWeek.endOf('week')];
        },
      },
      {
        label: 'Last 7 Days',
        getValue: () => {
          const today = dayjs();
          return [today.subtract(7, 'day'), today];
        },
      },
      {
        label: 'Current Month',
        getValue: () => {
          const today = dayjs();
          return [today.startOf('month'), today.endOf('month')];
        },
      },
      {
        label: 'Next Month',
        getValue: () => {
          const today = dayjs();
          const startOfNextMonth = today.endOf('month').add(1, 'day');
          return [startOfNextMonth, startOfNextMonth.endOf('month')];
        },
      },
      { label: 'Reset', getValue: () => [null, null] },
    ];


export default function Calender({value, setValue}) {
  console.log('value', value)


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['SingleInputDateRangeField']} >
        <DateRangePicker
          slots={{ field: SingleInputDateRangeField }}
          slotProps={{ textField: { InputProps: { endAdornment: <Calendar /> } },  
          shortcuts: { items: shortcutsItems }
          }}
          value={value}
          label='Date Range'
          onChange={(newValue)=>setValue(newValue)}
          sx={{ width: '20px' }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}




// import * as React from 'react';
// import dayjs from 'dayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { StaticDateRangePicker } from '@mui/x-date-pickers-pro/StaticDateRangePicker';

// const shortcutsItems = [
//   {
//     label: 'This Week',
//     getValue: () => {
//       const today = dayjs();
//       return [today.startOf('week'), today.endOf('week')];
//     },
//   },
//   {
//     label: 'Last Week',
//     getValue: () => {
//       const today = dayjs();
//       const prevWeek = today.subtract(7, 'day');
//       return [prevWeek.startOf('week'), prevWeek.endOf('week')];
//     },
//   },
//   {
//     label: 'Last 7 Days',
//     getValue: () => {
//       const today = dayjs();
//       return [today.subtract(7, 'day'), today];
//     },
//   },
//   {
//     label: 'Current Month',
//     getValue: () => {
//       const today = dayjs();
//       return [today.startOf('month'), today.endOf('month')];
//     },
//   },
//   {
//     label: 'Next Month',
//     getValue: () => {
//       const today = dayjs();
//       const startOfNextMonth = today.endOf('month').add(1, 'day');
//       return [startOfNextMonth, startOfNextMonth.endOf('month')];
//     },
//   },
//   { label: 'Reset', getValue: () => [null, null] },
// ];

// export default function BasicRangeShortcuts() {
//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <StaticDateRangePicker
//         slotProps={{
//           shortcuts: {
//             items: shortcutsItems,
            
//           },
//           actionBar: { actions: ['cancel', 'accept'] } ,
//         }}
//         calendars={2}
//       />
//     </LocalizationProvider>
//   );
// }